import { render, staticRenderFns } from "./JdsAttributeSticker.vue?vue&type=template&id=6822fa4a&scoped=true&"
import script from "./JdsAttributeSticker.vue?vue&type=script&lang=ts&"
export * from "./JdsAttributeSticker.vue?vue&type=script&lang=ts&"
import style0 from "./JdsAttributeSticker.vue?vue&type=style&index=0&id=6822fa4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822fa4a",
  null
  
)

export default component.exports